/**
 * Created by katarinababic on 12/06/2020.
 *
 * UNIFIED TYPOGRAPHY — aligned with light.kinastic.com
 * Headers: Montserrat weight 500, letter-spacing -0.6px
 * Body: Poppins, letter-spacing -0.18px
 */
import { Typography } from './Typography';
import { Colors } from './Colors';

export const Text = {
  body1: {
    color: Colors.darkGrey,
    ...Typography.font.normal,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  body2: {
    color: Colors.primaryText,
    ...Typography.font.bold,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  body3: {
    color: Colors.darkGrey,
    ...Typography.font.heavy,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  bodyItalic: {
    color: Colors.darkGrey,
    ...Typography.font.italic,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  button1: {
    color: Colors.primaryDarkest,
    ...Typography.font.normal,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  button2: {
    color: Colors.primaryDarkest,
    ...Typography.font.bold,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  medium16: {
    color: Colors.primaryText,
    ...Typography.font.medium,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  medium14: {
    color: Colors.primaryText,
    ...Typography.font.medium,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  caption1: {
    color: Colors.darkGrey80,
    ...Typography.font.normal,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  caption2: {
    color: Colors.darkGrey80,
    ...Typography.font.bold,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  captionItalic: {
    color: Colors.darkGrey80,
    ...Typography.font.italic,
    fontSize: 14,
    letterSpacing: '-0.18px',
  },
  header: {
    color: Colors.primaryText,
    ...Typography.font.medium,
    fontSize: 24,
    letterSpacing: '-0.6px',
  },
  headerNormal: {
    color: Colors.primaryText,
    ...Typography.font.normal,
    fontSize: 24,
    letterSpacing: '-0.6px',
  },
  headerLight: {
    color: Colors.primaryText,
    ...Typography.font.light,
    fontSize: 24,
    letterSpacing: '-0.6px',
  },
  italic: {
    color: Colors.primaryText,
    ...Typography.font.heavyItalic,
    fontStyle: 'italic',
    fontSize: 14,
  },
  subtitle1: {
    color: Colors.darkGrey70,
    ...Typography.font.normal,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  subtitle2: {
    color: Colors.darkGrey70,
    ...Typography.font.bold,
    fontSize: 16,
    letterSpacing: '-0.18px',
  },
  tiny1: {
    color: Colors.darkGrey70,
    ...Typography.font.normal,
    fontSize: 12,
    letterSpacing: '-0.18px',
  },
  tiny2: {
    color: Colors.darkGrey70,
    ...Typography.font.bold,
    fontSize: 12,
    letterSpacing: '-0.18px',
  },
  title: {
    color: Colors.primaryText,
    ...Typography.font.medium,
    fontSize: 18,
    letterSpacing: '-0.6px',
  },
  titleItalic: {
    color: Colors.primaryText,
    ...Typography.font.boldItalic,
    fontSize: 18,
    letterSpacing: '-0.6px',
  },
  titleNormal: {
    color: Colors.primaryText,
    ...Typography.font.normal,
    fontSize: 18,
    letterSpacing: '-0.6px',
  },
  titleLight: {
    color: Colors.primaryText,
    ...Typography.font.light,
    fontSize: 18,
    letterSpacing: '-0.6px',
  },
};
